export default "__VITE_ASSET__AQU0vVi5__"